import React from 'react';
import { Link } from 'react-router-dom';

import './NavLinks.css';

const NavLinks = (props) => (
	<ul className="App__NavLinks">
		<li>
			<Link to='/about'>About</Link>
		</li>
		<li>
			<Link to='/'>Work</Link>
		</li>
		<li>
			<a href='https://roblee.bigcartel.com/'>Shop</a>
		</li>
		<li>
			<Link to='/contact'>Contact</Link>
		</li>
	</ul>
);

NavLinks.propTypes = {  
};

export default NavLinks;


// WEBPACK FOOTER //
// ./src/components/NavLinks.js